import styled from 'styled-components';

export interface BadgeProps {
    color: string;
}

export const Badge = styled.span<BadgeProps>`
    padding: 0.1rem 0.3rem;
    border-radius: 0.3rem;
    color: white;
    background-color: ${({ color }) => color};
`;
